import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import iconApplication from '../../../assets/images/ad/application.webp';
import doubleiPhone from '../../../assets/images/ad/doubleiphoneMRH.webp';
import iconFirst from '../../../assets/images/ad/first.webp';
import iconGroup from '../../../assets/images/ad/group.webp';
import iconHalal from '../../../assets/images/ad/halal.webp';
import iconHandshake from '../../../assets/images/ad/handshake.webp';
import iconInternational from '../../../assets/images/ad/international.webp';
import ipadMRH from '../../../assets/images/ad/ipadMRH.webp';
import iphoneEmail from '../../../assets/images/ad/iphoneEmail.webp';
import iphoneMRH from '../../../assets/images/ad/iphoneMRH.webp';
import iconNoDrinks from '../../../assets/images/ad/no-drinks.webp';
import iconSmartphone from '../../../assets/images/ad/smartphone.webp';
import { Typography } from '@/components/atoms/Typography';
import { BentoGrid } from '@/components/molecules/BentoGrid';
import { HighlightGrid } from '@/components/molecules/HighlightGrid';
import { ImageBlocks } from '@/components/molecules/ImageBlocks';

type AdInfosProps = {
  containerClassName?: string;
};

export const AdInfos: React.FC<AdInfosProps> = ({ containerClassName }: AdInfosProps) => {
  const { t } = useTranslation();

  const IMAGES = [
    {
      title: t('promotion.eligibility.onlyHalal'),
      src: iconHalal
    },
    {
      title: t('promotion.eligibility.noAlcohol'),
      src: iconNoDrinks
    },
    {
      title: t('promotion.eligibility.referenced'),
      src: iconApplication
    },
    {
      title: t('promotion.eligibility.cityFree'),
      src: iconInternational
    }
  ];

  const WHYMRH_IMAGES = [
    {
      title: t('promotion.whyMRH.item1'),
      src: iconFirst
    },
    {
      title: t('promotion.whyMRH.item2'),
      src: iconGroup
    },
    {
      title: t('promotion.whyMRH.item3'),
      src: iconHandshake
    },
    {
      title: t('promotion.whyMRH.item4'),
      src: iconSmartphone
    }
  ];

  const leftSection = {
    title: t('promotion.highlightGrid.leftSection.title'),
    items: [t('promotion.highlightGrid.leftSection.item1'), t('promotion.highlightGrid.leftSection.item2'), t('promotion.highlightGrid.leftSection.item3')]
  };

  const rightSection = {
    title: t('promotion.highlightGrid.rightSection.title'),
    items: [t('promotion.highlightGrid.rightSection.item1'), t('promotion.highlightGrid.rightSection.item2')]
  };

  return (
    <section className={classNames(containerClassName, 'space-y-20')}>
      <section>
        <div className="mb-32">
          <div className="flex flex-col gap-2 mb-10 px-5 md:px-0">
            <Typography tag="p" variant="h1" weight="bold" align="center">
              {t('promotion.bendo.title')}
            </Typography>
            <Typography tag="p" variant="h3" align="center" color="gray">
              {t('promotion.bendo.subtitle')}
            </Typography>
          </div>

          <BentoGrid
            primaryTitle={t('promotion.bendo.firstGrid.title')}
            primaryCaption={t('promotion.bendo.firstGrid.subtitle')}
            primaryImage={ipadMRH}
            secondaryTitle={t('promotion.bendo.secondGrid.title')}
            secondaryCaption1={t('promotion.bendo.secondGrid.subtitle')}
            secondaryCaption2={t('promotion.bendo.secondGrid.secondSubtitle')}
            thirdTitle={t('promotion.bendo.thirdGrid.title')}
            thirdCaption={t('promotion.bendo.thirdGrid.subtitle')}
            thirdImage={iphoneMRH}
            fourthTitle={t('promotion.bendo.fourthGrid.title')}
            fourthCaption={t('promotion.bendo.fourthGrid.subtitle')}
            fourthImage={iphoneEmail}
          />
        </div>
      </section>

      <section className="flex flex-col gap-10 py-10 mb-32">
        <span className="flex flex-col gap-2 px-5 md:px-0">
          <Typography tag="p" variant="h1" weight="bold" align="center">
            {t('promotion.whyMRH.title')}
          </Typography>
          <Typography tag="p" variant="h3" align="center" color="gray">
            {t('promotion.whyMRH.subtitle')}
          </Typography>
        </span>
        <ImageBlocks images={WHYMRH_IMAGES} bgClassName="bg-primary border-primary" />
      </section>

      <section>
        <div className="flex flex-col gap-2 mb-10 px-5 md:px-0">
          <Typography tag="p" variant="h1" weight="bold" align="center">
            {t('promotion.highlightGrid.title')}
          </Typography>
          <Typography tag="p" variant="h3" align="center" color="gray">
            {t('promotion.highlightGrid.subtitle')}
          </Typography>
        </div>
        <HighlightGrid leftSection={leftSection} rightSection={rightSection} imageSrc={doubleiPhone} />
      </section>

      <section className="flex flex-col gap-10 py-10 bg-primary xl:rounded-tr-[60px]">
        <span className="flex flex-col gap-2 px-5 md:px-0">
          <Typography tag="p" variant="h1" weight="bold" align="center" color="white">
            {t('promotion.eligibility.title')}
          </Typography>
          <Typography tag="p" variant="h3" align="center" color="white">
            {t('promotion.eligibility.subtitle')}
          </Typography>
        </span>
        <ImageBlocks images={IMAGES} color="white" bgClassName="bg-green/90 border-green" />
      </section>
    </section>
  );
};
